import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Download } from "lucide-react";

const FAQS = [
  {
    q: "What is ArenaCoin (ARC)?",
    a: "ARC is the native utility token of Arena Platform — a series of PvP multiplayer betting tournaments. ARC unlocks fee discounts, VIP tournaments, ARC-only competitions and creator-tier tournament access.",
  },
  {
    q: "How does the 7-8% commission model work?",
    a: "The platform charges a flat 8% commission on every prize pool. If the tournament creator wins their own tournament, the commission drops to 7%. Operators never trade against players, so there is zero house liability.",
  },
  {
    q: "What is the total supply and is it fixed?",
    a: "100,000,000 ARC. Fixed supply — the BEP-20 contract has no mint function, no rebase, no reflection and no auto-tax. All tokens are minted once in the constructor and split across six immutable allocations.",
  },
  {
    q: "Where is ARC deployed?",
    a: "ArenaCoin V1 is BEP-20 on BNB Smart Chain. No multichain or bridge in V1 — V1 is intentionally minimal: safe, simple, ossified.",
  },
  {
    q: "Is the smart contract audited?",
    a: "The contract is built on OpenZeppelin v5 (audited industry standard) with no custom math beyond constructor allocation. An external audit is scheduled before mainnet deployment, and the audit report will be published alongside the verified BscScan source.",
  },
  {
    q: "How does team vesting work?",
    a: "10% of supply (10M ARC) is locked in an immutable on-chain vesting wallet with a 6-month cliff and 24-month linear release after the cliff. Total schedule: 30 months. Anyone can trigger release(), but funds only ever flow to the team multisig.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#00F0FF]">// signal</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-2">
            Questions, <span className="glow-green text-[#39FF14]">answered.</span>
          </h2>
          <p className="mt-5 text-white/65 font-mono text-sm">
            Need the deep technical breakdown? The whitepaper covers token mechanics, prize-pool math
            and the audited contract.
          </p>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="btn-secondary inline-flex items-center gap-2 mt-6"
            data-testid="whitepaper-download-button"
          >
            <Download className="w-4 h-4" /> Download Whitepaper
          </a>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="glass divide-y divide-white/10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-0 px-5">
                <AccordionTrigger
                  className="font-display text-left text-base sm:text-lg font-bold py-5 hover:no-underline hover:text-[#39FF14]"
                  data-testid={`faq-question-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 font-mono text-sm leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
